

import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createEntitySliceSelectors } from '@aston/foundation';
import { IFederationListItem } from 'apps/console/src/app/federations-module/models';
import { AccessLevel } from 'apps/console/src/app/shared-module/enums';
import { NewFederationStep } from 'apps/console/src/app/federations-module/enums';

import { AppStoreSelectors } from '../app-store';

import { FeatureName } from './feature';
import { IFederationsState } from './state';

export const selectState: MemoizedSelector<object, IFederationsState> = createFeatureSelector<IFederationsState>(FeatureName);

export const getHasLoadedOnce = (state: IFederationsState): boolean => state.hasLoadedOnce;
export const selectHasLoadedOnce = createSelector(selectState, state => getHasLoadedOnce(state));
export const selectHasPendingFederations = createSelector(selectState, state => state.hasPendingItems);

export const {
	getEntity: getFederations,
	selectEntity: selectFederations,
	selectIsLoading: selectFederationsIsLoading,
	selectError: selectFederationsError
} = createEntitySliceSelectors(createSelector(selectState, state => state.federations));

export const getFederationsCount = (state: IFederationsState): number => state.federations.entity.length;
export const selectFederationsCount = createSelector(selectState, state => getFederationsCount(state));

export const getHasFederations = (state: IFederationsState): boolean => getFederationsCount(state) > 0;
export const selectHasFederations = createSelector(selectState, state => getHasFederations(state));

export const getFederationById = (federations: IFederationListItem[], id: number): IFederationListItem => federations.find(s => s.federationId === id);

export const selectCanCreateFederation = createSelector(selectFederations, AppStoreSelectors.selectCurrentUserIsSupport,
	(federations, isSupport) => isSupport && federations?.length >= 2 && federations?.find(s => s.accessLevel === AccessLevel.Admin));

export const {
	selectEntity: selectFederationEntity,
	selectIsLoading: selectFederationEntityIsLoading,
	selectError: selectFederationEntityError
} = createEntitySliceSelectors(createSelector(selectState, state => state.form));

export const selectNewFederationStep = createSelector(selectFederationEntity, f => f?.federationId ? NewFederationStep.Validation : NewFederationStep.Create);
